import * as S from './container.styles';
import type { ContainerProps } from './types';

export const Container = ({children, style}: ContainerProps) => {
    return (
        <S.Wrapper style={style}>{children}</S.Wrapper>
    )
}